<template>
    <v-row>
        <v-col cols="12" sm="12" v-if="tag_list.length>0" class="mb-2">
         <strong v-if="show_title" class="font-weight-bolder">Tags:</strong>
         <v-btn
            text
            small
            v-for="(tag,index) in tag_list"
            :key="index"
            :to="'/accounting/tag/'+tag"
            :color="isBranded ? undefined : ($vuetify.theme.isDark ? 'white' : 'blue')"
            :class="{ 'branded-back-btn': isBranded }"
            :style="isBranded ? backButtonStyle : {}"
         >#{{tag}}</v-btn>
        </v-col>
    </v-row>
    
</template>

<script>
import {
  getBrandSecondaryStyleVars,
  hasPartnerBrandColors,
} from "@/utils/brandColors";

export default {
        props:{
            tags:{
                default:'',
                type:String
            },
            show_title:{
                default: true,
                type:Boolean
            }
        },
        name: "anchorComponent",
        computed:{
            business() {
              return this.$store.state.user.user_infor.current_business;
            },
            isBranded() {
              return hasPartnerBrandColors(this.business);
            },
            backButtonStyle() {
              return this.isBranded ? getBrandSecondaryStyleVars(this.business) : {};
            },
            tag_list(){
                return this.tags ? this.tags.split(',') : '';
            }

        }
    }
</script>

<style scoped>
.branded-back-btn:hover,
.branded-back-btn:hover .v-btn__content,
.branded-back-btn:hover .v-icon {
  color: var(--brand-secondary) !important;
}
</style>
